import { memo } from 'react';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { View } from 'foundations-components/components/View';
import { ColorSquatch } from 'foundations-components/transitional/components/ColorSquatch';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { CampaignsIcon } from 'foundations-assets/icons/components/CampaignsIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CampaignsPlatformLabelTag({
  campaignCrmObject,
  onClick
}) {
  const leftBorderColor = getPropertyValue(campaignCrmObject, 'hs_color_hex', '');
  return /*#__PURE__*/_jsxs(Flex, {
    marginBlockStart: "100",
    "data-test-id": "campaigns-platform-label-tag",
    inlineSize: "max-content",
    backgroundColor: "fill-field-disabled",
    position: "relative",
    overflow: "hidden",
    borderRadius: "100",
    children: [leftBorderColor && /*#__PURE__*/_jsx(View, {
      position: "absolute",
      inlineSize: "9px",
      overflow: "hidden",
      marginBlockStart: "-100",
      marginInlineStart: "-100",
      children: /*#__PURE__*/_jsx(ColorSquatch, {
        size: 50,
        color: leftBorderColor
      })
    }), /*#__PURE__*/_jsx(View, {
      paddingBlock: "200",
      paddingInlineEnd: "250",
      paddingInlineStart: leftBorderColor ? '400' : '250',
      children: /*#__PURE__*/_jsx(Link, {
        onClick: onClick,
        children: /*#__PURE__*/_jsxs(Flex, {
          alignItems: "center",
          gap: "200",
          children: [/*#__PURE__*/_jsx(CampaignsIcon, {}), getPropertyValue(campaignCrmObject, 'hs_name')]
        })
      })
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformLabelTag);